import axios from "axios";
import { getAccessToken } from "./tokenStore";

const axiosConfig = {
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
};

const api = axios.create(axiosConfig);

api.interceptors.request.use(async (config) => {
  const token = await getAccessToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
